var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCardArrow = function SvgCardArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.13 2.836a.5.5 0 0 1 .74-.672l5 5.5a.5.5 0 0 1 0 .672l-5 5.5a.5.5 0 1 1-.74-.672L10.824 8 6.13 2.836z"
  }))));
};

export { SvgCardArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMCAwaDE2djE2SDB6Ii8+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTYuMTMgMi44MzZhLjUuNSAwIDAxLjc0LS42NzJsNSA1LjVhLjUuNSAwIDAxMCAuNjcybC01IDUuNWEuNS41IDAgMTEtLjc0LS42NzJMMTAuODI0IDggNi4xMyAyLjgzNnoiLz48L2c+PC9zdmc+";